import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../components/authContext";

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

export function useRequireListing() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      if (!user) {
        setChecking(false);
        return;
      }
      try {
        setChecking(true);
        const token = await user.getIdToken();
        const res = await fetch(`${API_BASE_URL}/api/create/prevalidation`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const json = await res.json();
        if (!alive) return;
        if (!res.ok) throw new Error(json?.error || "Failed to validate profile.");
        if (json.profileCreated) {
          setAllowed(true);
        } else {
          navigate("/create/listing", { replace: true, state: { from: location.pathname } });
        }
      } catch {
        if (alive) {
          navigate("/create/listing", { replace: true, state: { from: location.pathname } });
        }
      } finally {
        if (alive) setChecking(false);
      }
    })();
    return () => { alive = false; };
  }, [user, navigate, location.pathname]);

  return { checking, allowed };
}
